import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useParams, useNavigate } from "react-router-dom";
import { bandExists, getBandById } from "../utils/extractConfigData";
import Band from "../components/Band";
import { LeafRed } from "../components/Artwork";
import styles from "./Band.module.css";

const BandPage = () => {
  const { bandId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!bandExists(bandId)) {
      navigate("/notfound", { replace: true });
    }
  }, [bandId, navigate]);

  return (
    <div className={styles.bandPage}>
      <Helmet>
        <title>Band {getBandById(bandId).name}</title>
      </Helmet>
      
      <div className={styles.bandContainer}>
        <Band bandId={bandId} />
      </div>

      {/* Artwork positioned in a container - moved to bottom for higher z-index */}
      <div className={styles.artworkContainer}>
        <LeafRed 
          className={styles.artLeft} 
          style={{
            position: 'absolute', 
            zIndex: 5,
            left: '3%',
            top: '30%',
            width: '60px',
            maxWidth: '10%',
            display: 'block',
            opacity: 0.9
          }} 
        />
        <LeafRed 
          className={styles.artRight} 
          style={{
            position: 'absolute', 
            zIndex: 5,
            right: '5%',
            bottom: '20%',
            width: '60px',
            maxWidth: '10%',
            display: 'block',
            opacity: 0.9
          }} 
        />
      </div>
    </div>
  );
};

export default BandPage;
